import {NavLink, Link} from 'react-router-dom';
import {LockKeyhole, ShieldCheck, ArrowUpRight} from 'lucide-react';
import {Eyebrow} from './Common';

export const AuthShell = ({title, description, eyebrow, children}) => <section className="auth-section wrap simplified-auth">
  <div className="auth-story"><Eyebrow id="auth-story-eyebrow">MAHAKALI TRIBUNAL / YOUR ACCOUNT</Eyebrow>
    <h1 data-testid="auth-heading">An open conversation.<br/><em>A considered relationship.</em></h1>
    <p data-testid="auth-description">Create an investor account, share your interests and speak with our team. Private company materials remain subject to approval.</p>
    <div className="auth-principles"><span><ShieldCheck size={18}/> Direct investor registration</span><span><LockKeyhole size={18}/> Controlled private access</span></div>
    <Link className="auth-guest-link" to="/invest" data-testid="auth-continue-guest">Prefer to continue without an account? <ArrowUpRight size={14}/></Link>
    <div className="auth-story-bottom">INTELLIGENCE, JUSTICE & WEALTH</div>
  </div>
  <div className="auth-form-area"><nav className="auth-mode-tabs" aria-label="Account access">
    <NavLink to="/login" data-testid="auth-tab-signin">Sign in</NavLink>
    <NavLink to="/register" data-testid="auth-tab-register">Create account</NavLink>
    <NavLink to="/founder" data-testid="auth-tab-founder">Founder</NavLink>
  </nav><Eyebrow id="auth-form-eyebrow">{eyebrow}</Eyebrow><h2 data-testid="auth-form-title">{title}</h2>
    <p className="caption" data-testid="auth-form-description">{description}</p>{children}
  </div>
</section>;

export const ConfidentialityConsent = ({id = 'confidentiality-consent'}) => <label className="check-label">
  <input type="checkbox" name="confidentiality" required data-testid={id}/>
  <span>I will keep nonpublic company materials confidential and use them only to evaluate a potential relationship. Account creation is not an investment commitment.</span>
</label>;

export const loginDestination = (user, from) => user.role === 'admin' ? '/admin/capital' :
  (typeof from === 'string' && (/^\/invite\/[A-Za-z0-9_-]+$/.test(from) || /^\/portal(?:\/[a-z-]+)?$/.test(from))) ? from : '/portal';